import React from 'react';

import { Box, Grid, Typography } from '@mui/material';
import { NumberField, SelectField } from 'react-admin';

import { transactionMonitoringModesChoices } from '../../../constants/transactionMonitoringMode';
import { timePeriodChoices } from '../../../constants/timePeriods';
import labels from '../../../constants/labels';
import { ThresholdField } from './AmountThreshold';

const CategorizationThreshold = () => (
  <Grid
    alignItems="baseline"
    size={{
      xs: 12,
      sm: 6,
      lg: 4,
    }}
  >
    <Box display="flex" flexDirection="row" gap={1} alignItems="baseline" flexWrap="wrap">
      <Typography sx={{ fontWeight: 'bold', fontSize: 10 }}>
        Transaction monitoring mode
      </Typography>
      <SelectField
        choices={transactionMonitoringModesChoices}
        source="ruleParameters.transactionMonitoringMode"
        sx={{ fontSize: 10 }}
      />

      <Typography sx={{ fontWeight: 'bold', fontSize: 10 }}>
        Default threshold
      </Typography>
      <ThresholdField source="ruleParameters.default" fontSize={10} />

      <Typography sx={{ fontWeight: 'bold', fontSize: 10 }}>
        Period
      </Typography>
      <NumberField source="ruleParameters.period.amount" sx={{ fontSize: 10 }} />
      <SelectField source="ruleParameters.period.unit" choices={timePeriodChoices} sx={{ fontSize: 10 }} />

      <Typography sx={{ fontWeight: 'bold', fontSize: 10 }}>
        Category
      </Typography>
      <SelectField source="ruleParameters.category" choices={labels} sx={{ fontSize: 10 }} />
    </Box>
  </Grid>
);

export default CategorizationThreshold;
